<template>
<div>
  <table :class="$style['review-oparetion-table']">
    <pt-form-list-item label="审核操作：" :required="true" v-if="!isRefundCompleted&&!refundDialog">
      <wt-radio :radios="awardRadios" v-model="form.status" data-vv-as="审核状态" name="name" v-validate="'required'">></wt-radio>
    </pt-form-list-item>
    <pt-form-list-item label="驳回原因：" :required="true" v-if="form.status==='REJECTED'">
      <wt-radio v-if="isRefundReject" :radios="rejectMethods" v-model="form.refundMethodId" data-vv-as="驳回原因"
      name="REJECTED" v-validate="'required'" :props="{value:'id',label:'reason'}"></wt-radio>
      <wt-input v-else type="textarea" :autosize="{ minRows: 2, maxRows: 6 }" v-model="form.rejectReason" v-validate="'required'" data-vv-as="驳回原因" name="REJECTED"></wt-input>
    </pt-form-list-item>
    <pt-form-list-item label="退款原因：" required v-if="refundDialog">
       <wt-input v-if="isRefundCompleted" type="textarea" :autosize="{ minRows: 2, maxRows: 6 }" v-model="form.rejectReason" v-validate="'required'"
        data-vv-as="退款原因" name="REJECTED"></wt-input>
       <wt-radio v-else :radios="rejectMethods" v-model="form.refundMethodId" data-vv-as="驳回原因"
      name="REJECTED" v-validate="'required'" :props="{value:'id',label:'reason'}"></wt-radio>
    </pt-form-list-item>
    <pt-form-list-item label="退款金额：" v-if="refundMoney">
      <div :class="$style['refund-money']">{{refundMoney}}元</div>
    </pt-form-list-item>
    <pt-form-list-item v-if="form.status!=='remindPay'" label="备注：" :required="form.status==='REJECTED'?true:false">
      <wt-input type="textarea" :autosize="{ minRows: 2, maxRows: 6 }" v-model="form.remark"  v-validate="form.status==='REJECTED'?'required':null" data-vv-as="备注"></wt-input>
    </pt-form-list-item>
  </table>
</div>
</template>
<script>
import { awardRadios, awardRadiosHasRemindPay } from './award-audit'
import formMixins from 'mixins/form'
export default {
  mixins: [formMixins],
  props: {
    fromPage: {
      type: String,
      default: null
    },
    userType: {
      type: String,
      default: null
    },
    auditState: {
      type: String,
      default: null
    },
    selectTab: {
      type: String,
      default: null
    },
    isBatch: {
      type: Boolean,
      default: false
    },
    approvaled: {
      type: Boolean,
      default: false
    },
    isRefundReject: {
      type: Boolean
    },
    rejectMethods: {
      type: Array
    },
    isRefund: {
      type: Boolean
    },
    isRefundCompleted: {
      type: Boolean
    },
    auditAlreadyRefund: {
      type: Boolean
    },
    refundDialog: {
      type: Boolean
    }
  },
  data () {
    return {
      form: {
      },
      refundMoney: null
    //   awardRadios: (this.fromPage === 'detail' && this.userType === 'OLD') ? awardRadiosHasRemindPay : awardRadios
    }
  },
  computed: {
    awardRadios () {
      return ((this.userType === 'OLD' && (this.selectTab === 'WAITING_FOR_APPROVAL' || this.auditState === 'WAITING_FOR_APPROVAL')) ||
      (this.isBatch && this.selectTab === 'WAITING_FOR_APPROVAL')) ? awardRadiosHasRemindPay : awardRadios
    }
  },
  watch: {
    rejectMethods (val) {
      if (this.isRefundCompleted) {
        this.refundMoney = val[0].money
      }
    },
    form: {
      handler: function (val) {
        this.$emit('input', val)
      }
    },
    approvaled (val) {
      if (val) {
        for (var key in val) {
          delete val[key]
        }
      }
    },
    'form.refundMethodId' (val) {
      if (val) {
        this.rejectMethods.forEach(item => {
          if (item.id === val) {
            if (!this.auditAlreadyRefund) {
              this.refundMoney = item.money
            }
          }
        })
      }
    },
    'form.status' (val) {
      if (val !== 'REJECTED') {
        this.refundMoney = null
        this.$set(this.form, 'refundMethodId', null)
      }
    }
  }
}
</script>
<style module lang="less">
.review-oparetion-table{
  padding: 0 20px
}
.refund-money{
  color: #edbe81;
  font-weight: 600
}
</style>
